export default "__VITE_ASSET__e1b5d1ed__"